import { useContext } from "react";

import ToastContext from "contexts/ToastContext.tsx";

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("コンテストエラー");
  }
  return context;
};
